const STORAGE_PREFIX = 'analytics.cols.';

export interface ColumnPrefsScope {
  domain: string;
  /** Group-by value (or 'rows' for ungrouped). Ignored when isDrillDown is true. */
  groupBy: string;
  isDrillDown: boolean;
}

/** Drill-down column choices are intentionally not persisted: each drill-down resets to defaults. */
const isPersistable = (scope: ColumnPrefsScope) => !scope.isDrillDown;

const storageKey = (scope: ColumnPrefsScope): string => `${STORAGE_PREFIX}${scope.domain}.${scope.groupBy}`;

export const loadColumnPrefs = (scope: ColumnPrefsScope): string[] | null => {
  if (!isPersistable(scope)) return null;
  try {
    const raw = localStorage.getItem(storageKey(scope));
    if (!raw) return null;
    const parsed: unknown = JSON.parse(raw);
    if (!Array.isArray(parsed)) return null;
    return parsed.filter((v): v is string => typeof v === 'string');
  } catch {
    return null;
  }
};

export const saveColumnPrefs = (scope: ColumnPrefsScope, keys: string[]): void => {
  if (!isPersistable(scope)) return;
  try {
    localStorage.setItem(storageKey(scope), JSON.stringify(keys));
  } catch {
    // Storage quota or disabled — silently ignore; column choice falls back to defaults next visit.
  }
};
